import { useState } from 'react';
import { throttle } from '../lib/Utils/throttle';
import { useEventListener } from '../lib/Utils/useEventListener';
import { useIsomorphicLayoutEffect } from '../lib/Utils/useIsomorphicLayoutEffect';

interface WindowSize {
	width: number;
	height: number;
}

export function useThrottledWindowSize(): WindowSize {
	const [windowSize, setWindowSize] = useState<WindowSize>({
		width: 0,
		height: 0,
	});

	const handleSize = throttle(() => {
		setWindowSize({
			width: window.innerWidth,
			height: window.innerHeight,
		});
	});

	useEventListener('resize', handleSize);

	// Set size at the first client-side load
	useIsomorphicLayoutEffect(() => {
		handleSize();
	}, []);

	return windowSize;
}
